import React from 'react';
import { Link, useIntl } from 'gatsby-plugin-intl';
import "./Breadcrumbs.css"


const Breadcrumbs = ({ crumbs }) => {
  const intl = useIntl();

  return (
    <ul className='DisFlex'>
      <li>
        <Link to="/">{intl.formatMessage({ id: 'home', defaultMessage: 'Accueil' })}</Link>
      </li>
      {crumbs.map((crumb, index) => (
        <li key={index}>
          <Link to={crumb.link}>
            {intl.formatMessage({ id: crumb.label })}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Breadcrumbs;
